export * from './UIGameTradeOfferAcceptTradeButton.tsx';
